<template>
  <div
    :class="mergedClasses"
    v-bind="passthroughAttrs"
  >
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdCardText',

  inheritAttrs: false,

  emits: [],

  computed: {
    mergedClasses() {
      return [this.$attrs.class, 'card-text'].flat().filter(Boolean);
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
